import * as z from "zod";

import { roleSchema } from "./role";
import { userSchema } from "./user";

export const roleWithDetailsSchema = roleSchema.extend({
  updatedBy: userSchema,
  assignedTo: z.array(userSchema).default([]),
});

export type RoleWithDetails = z.infer<typeof roleWithDetailsSchema>;
